export default __webpack_public_path__ + "static/media/nispidjaxxx-color.fa86054d.svg";